import CustomerUptimeResourceModel from '../../generated/types/model/resource/CustomerUptimeResourceModel';

export default class CustomerUptimeResourceViewModel extends CustomerUptimeResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
